/**
 * The main js file for the theme
 *
 * This is the entry point where all modules are imported and compiled.
 *
 * @package Embark
 * @since   1.0.0
 */


import './modules/theme/polyfills';
import './modules/theme/webfonts';
import './modules/theme/images';
import './modules/theme/object-fit-videos';
import './modules/theme/lightboxes';
import './modules/theme/forms';
import './modules/theme/scroll-to';
import './modules/theme/sticky-reveal-header';
import './modules/theme/main-menu';
import './modules/theme/comment-reply';
import './modules/theme/spotlight-carousel';
import './modules/theme/people-awards';
import './modules/theme/mobile-stack-menu';
import './modules/theme/searchform';
import './modules/theme/widgets';
import './modules/theme/article-slick-slider';
import './modules/theme/video-carousel';
import './modules/theme/accordion';
import './modules/theme/clinical-trials';
import './modules/theme/resource-publications';
import './modules/theme/resource-display';
import './modules/theme/link-group';
import './modules/theme/yoast-faq-block';
import './modules/theme/post-list';
import './modules/theme/cards';
import './modules/theme/sticky-cta';
import './modules/theme/responsive-tables';
import './modules/theme/tabs';
import './modules/theme/links';
import './modules/theme/deep-footer';
import './modules/theme/iframes';
import './modules/theme/recent-posts-widget';
import './modules/theme/content-background';
import './modules/theme/glossary';
import './modules/theme/disclaimer-modal';
import './modules/theme/swap-numbers';
import './modules/theme/doctor-finder';
import './modules/theme/home-search';
import './modules/theme/em-locator';
import './modules/theme/gravity-forms';
import './modules/theme/page-navigation';
